import { Box, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { ArticleCardVariantLabel } from '../components/article-card-variant-label';
import { useArticleCardContext } from '../article-card';

const StyledBox = styled(Box)(({ theme }) => ({
    ...theme.typography.caption,
    color: theme.palette.grey['800'],
    paddingBottom: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    paddingTop: 0,
    gap: 0,
    justifyContent: 'space-between',
}));

const ActionLabelPlaceholder = styled(Box)(({ theme }) => ({
    minHeight: theme.spacing(2.75),
}));

export const ArticleCardContentArticleNumber = (): ReactElement => {
    const { article } = useArticleCardContext();

    return (
        <StyledBox>
            <PoolTypography variant="caption" component="div">
                <FormattedMessage id="app.article.number.abbreviation" values={{ value: article.number }} />
            </PoolTypography>
            {article.hasVariants ? <ArticleCardVariantLabel /> : <ActionLabelPlaceholder />}
        </StyledBox>
    );
};
